import { Component, OnInit, OnChanges, Input } from '@angular/core';
import * as _ from 'lodash';
import { ProjectService } from '../../../../services/project.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTitleService } from '../../../../services/core.title.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'project-admin-edit',
  template: require('./project.admin.edit.html')
})
export class ProjectAdminEditComponent implements OnInit {
  @Input() project: any;
  @Input() isProjectAdmin: any;

  projectEdit: any;
  deleteData: any;
  publicPrivate: any;
  yesNo: any;
  isLoading: boolean = true;

  constructor(
    private projectService: ProjectService,
    private uiService: UiService,
    private stateService: StateService,
    private titleService: GfTitleService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.project.name, 'Admin', 'Edit');

    this.publicPrivate = {
      'Public': 'Y',
      'Private': 'N'
    };

    this.yesNo = {
      'Yes': 'Y',
      'No': 'N'
    };

    this.init();
  }

  ngOnChanges() {
    this.init();
  }

  private init() {
    if (!this.project) {
      return;
    }

    this.projectEdit = {
        id: this.project.id,
        isPublic: this.project.isPublic,
        isTemplate: this.project.isTemplate,
        description: this.project.description,
        homepageUrl: this.project.homepageUrl,
        name: this.project.name
      };
  
      this.resetDelete();
  
      this.isLoading = false;
  }


  setProjectModelDataField(fieldName: string, value: any): boolean {
    if (value === undefined || value === _.get(this.projectEdit, fieldName)) {
      return false;
    }
    this.projectEdit[fieldName] = value;
    return true;
  }

  setIsPublic(value: any): boolean {
    return this.setProjectModelDataField('isPublic', value);
  }

  setIsTemplate(value: any): boolean {
    return this.setProjectModelDataField('isTemplate', value);
  }

  save(): void {
    const saving = _.cloneDeep(this.projectEdit);
    this.projectService.save(this.project.unixName, saving)
      .then(() => {
        this.uiService.message.showSuccess('Changes saved!');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((response) => {
        if (response?.status === 403) {
          const message = typeof response.error === 'string' ? response.error : 'Permission denied.';
          this.uiService.message.showWarning(message, 'Permission Denied');
        } else {
          this.uiService.message.showWarning('Failed to save!');
        }
      });
  }

  resetDelete(): void {
    this.deleteData = {
      scmType: _.filter(_.get(this, 'project.rel.plugins', []), (plugin: string) => plugin.startsWith('scm'))
        .map((plugin: string) => plugin.replace('scm', ''))[0],
      scmChoice: 0,
      deleteConfirm: ''
    };
  }

  canDelete(): boolean {
    // Orgs or projects with no SCM plugin don't use the SCM repository choice section.
    if (!this.deleteData.scmType) {
      return this.deleteData.deleteConfirm === this.project.unixName;
    }
    // Projects with SCM plugin require the user to select a repository option.
    return (this.deleteData.scmChoice !== 0 &&
            this.deleteData.deleteConfirm === this.project.unixName);
  }

  deleteProject(): void {
    this.projectService.delete(this.project.unixName)
      .then(() => {
        this.uiService.message.showSuccess("This project has been marked Deleted.", "Delete Project");
        this.stateService.go('home.project.summary', { unixName: this.project.unixName }, {location: true });
      })
      .catch(response => {
        this.uiService.message.showWarning("Sorry, could not delete this Project.", "Delete Project");
        console.log(response);
      });
  }
}
